// src/pages/ContactPage.jsx
import React from "react";
import ContactForm from "../components/Contact/ContactForm";
import ContactInfo from "../components/Contact/ContactInfo";
import SEO from "../components/common/SEO";

const ContactPage = () => {
  const contactStructuredData = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "name": "Contact Mihir Shah - OWASP VXDF Project Leader",
    "description": "Get in touch with Mihir Shah for cybersecurity consulting, speaking engagements, OWASP VXDF collaboration, or security project discussions.",
    "url": "https://mihirshah.tech/contact",
    "mainEntity": {
      "@type": "Person",
      "name": "Mihir Shah",
      "jobTitle": "OWASP VXDF Project Leader & Security Engineer",
      "email": "hello@mihirshah.tech",
      "url": "https://mihirshah.tech",
      "sameAs": [
        "https://github.com/mihir-shah99",
        "https://linkedin.com/in/mihir-shah99",
        "https://x.com/mihirshah99"
      ],
      "offers": [
        {
          "@type": "Service",
          "name": "Cybersecurity Consulting",
          "description": "Expert cloud security and application security consulting"
        },
        {
          "@type": "Service", 
          "name": "Speaking Engagements",
          "description": "Conference talks and presentations on OWASP VXDF and security topics"
        },
        {
          "@type": "Service",
          "name": "Security Training",
          "description": "Professional cybersecurity training and workshops"
        }
      ]
    }
  };

  return (
    <>
      <SEO
        title="Contact - Mihir Shah | Cybersecurity Consulting & Speaking"
        description="Contact Mihir Shah for cybersecurity consulting, cloud security expertise, OWASP VXDF collaboration, speaking engagements, and security project discussions. Professional cybersecurity services."
        keywords="contact Mihir Shah, cybersecurity consulting, cloud security consultant, OWASP expert, security speaking engagements, VXDF collaboration, security training"
        url="https://mihirshah.tech/contact"
        type="website"
        section="Contact"
        tags={["Contact", "Consulting", "Speaking", "Cybersecurity Services"]}
        structuredData={contactStructuredData}
      />
      <div className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900 py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-vxdf-primary to-vxdf-accent bg-clip-text text-transparent">
              Let&apos;s Connect
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Ready to discuss cybersecurity challenges, OWASP VXDF collaboration, or explore new opportunities? I&apos;d love to hear from you.
            </p>
          </div>
          <div className="grid lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
            <ContactInfo />
            <ContactForm />
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactPage;
